<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12 tabs">
                <div class="row" v-if="!partner">
                    <div class="col-6 active tab">
                        <span>Интеллектуальный заказ </span>
                        <button class="btn btn-outline-primary infoButton" @click="openHowTo()"><i class="las la-info"></i></button>
                        <span class="count">{{ count.number }}</span>
                    </div>
                    <a href="/orderFromCatalog" class="col-6 tab">
                        <span>Ручной заказ</span>
                        <span class="count">{{ count.manual }}</span>
                    </a>
                </div>
                <div class="row" v-if="partner">
                    <div class="col-4 active tab">
                        <span>Интеллектуальный заказ </span>
<!--                        <button class="btn btn-outline-primary infoButton" @click="openHowTo()"><i class="las la-info"></i></button>-->
                        <span class="count">{{ count.number }}</span>
                    </div>
                    <a href="/orderFromCatalog" class="col-4 tab">
                        <span>Ручной заказ</span>
                        <span class="count">{{ count.manual }}</span>
                    </a>
                    <a href="/orderFromCatalogPartner" class="col-4 tab">
                        <span>Заказ для партнеров</span>
                        <span class="count">{{ count.manual2 }}</span>
                    </a>
                </div>
            </div>

            <aside class="col-md-4">
                <div class="p-4 mb-3 bg-light rounded">
<!--                    <button class="btn btn-outline-primary btn-block" @click="openHowTo()"><i class="las la-info"></i> Как это работает</button>-->
<!--                    <br/>-->
                    <ol class="list-unstyled" style="margin-bottom: 0">
                        <li v-for="menuItem in menu" v-bind:key="menuItem.id" style="position: relative">
                            <a :href="'/configurator/' + menuItem.id">{{menuItem.folder}} {{menuItem.alt_folder}}</a>
                            <a href="#" @click="showAction = true" v-if="['28737','28739','28743'].indexOf(menuItem.id) != -1" style="position: absolute; right: -5px; top: 6px;"><img src="./../assets/img/action50info.png" style="width: 30px;" /></a>
                        </li>
                    </ol>
                </div>
            </aside>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-4" v-for="menuItem in menu" v-bind:key="menuItem.id">
                        <a class="card mb-4 shadow-sm" :href="'/configurator/' + menuItem.id">
<!--                            <div class="bd-placeholder-img card-img-top" width="100%" height="225" :style="'background-image: url(\'./img/' + menuItem.image + '\')'">-->
                            <div class="bd-placeholder-img card-img-top" style="text-align: center; font-size: 50px; color: #bdbdbd">
                                <i v-if="!menuItem.action || noActionIDs.indexOf(Number(menuItem.id_good)) != -1" class="las la-plus"></i>
                                <img v-else-if="actionIDs.indexOf(Number(menuItem.id_good)) != -1" src="./../assets/img/typeAction2.jpg" />
                                <img v-else src="./../assets/img/typeAction.png" />
                                <!--<img v-if="menuItem.action" src="./../assets/img/actionGet.png" />-->
                            </div>
                            <div class="card-body">
                                <p class="card-text">{{menuItem.folder}} {{menuItem.alt_folder}}</p>
                                <a href="#" @click="showAction = true" v-if="['28737','28739','28743'].indexOf(menuItem.id) != -1" style="width: 100%; display: inline-block; text-align: center;"><img src="./../assets/img/action50info.png" style="width: 30px;" /></a>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <modal name="how-to" :min-width="200"
                   :min-height="200"
                   :adaptive="true"
                   :scrollable="true"
                   :reset="true"
                   width="100%"
                   height="auto">
                <div style="padding: 20px; font-size: 13px;">
                    <div id="aboutBlock"></div>

                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="closeHowTo()">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="sale" :min-width="200"
                   :min-height="200"
                   :adaptive="true"
                   :scrollable="true"
                   :reset="true"
                   width="60%"
                   height="auto">
                <div style="padding: 20px">
                    <div>
                        <p><strong>Мы пролонгировали специальное предложение до 10.04.2025.</strong></p>
                        <!--                        <p>Уважаемые партнеры!</p>-->
                        <p>При размещении заказа на комплектующие, увеличена система скидок <strong>на</strong><strong style="color: rgb(230, 0, 0);"> 5%</strong><strong>-ных пункта.</strong></p>
                        <p>Обратите внимание, новая система скидок отображается при заказе у вас в личном кабинете.</p>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="$modal.hide('sale')">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="sale50action" :min-width="200"
                   :min-height="200"
                   :adaptive="true"
                   :scrollable="true"
                   :reset="true"
                   width="60%"
                   height="auto">
                <div style="padding: 20px">
                    <div>
                        <p><strong>Мы пролонгировали специальное предложение до 10.04.2025.</strong></p>
                        <!--                        <p>Уважаемые партнеры!</p>-->
                        <p>При размещении заказа на комплектующие, увеличена система скидок <strong>на</strong><strong style="color: rgb(230, 0, 0);"> 5%</strong><strong>-ных пункта.</strong></p>
                        <p>Обратите внимание, новая система скидок отображается при заказе у вас в личном кабинете.</p>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="$modal.hide('sale50action')">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <div v-if="showAction">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-container">
                            <a href="#" @click="showAction = false" style="position: absolute; top: 0px; right: 10px; font-size: 32px">X</a>
                            <p style="text-transform: uppercase; color: red; font-size: 30px; font-weight: bold; text-align: center">Распродажа готовых изделий RM</p>
                            <div class="row">
                                <div class="col-4"></div>
                                <div class="col-8" style="text-align: center">
                                    <p style="font-size: 30px">До 31 июля действует скидка<br/><span style="font-size: 40px;">50%</span><br/> на рулонные шторы MINI,<br/> на рулонные шторы Zebra Slim,<br/> и горизонтальные жалюзи стандартные</p>
                                    <a href="/readyMade" style="text-decoration: underline; font-size: 30px; text-transform: uppercase">Перейти для заказа</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import ai_helper from '../js/aihelper/ai_helper';

    export default {
        name: "AccessoriesOrdering",
        metaInfo: {
            title: 'Заказ комплектующих',
            titleTemplate: '%s - sale.katris'
        },
        props: ['new'],
        data() {
            return {
                menu: [],
                count: {
                    number: 0,
                    basket: 0,
                    manual: 0,
                    manual2: 0
                },
                actionIDs: [],
                noActionIDs: [],

                partner: false,

                showAction: false
            }
        },
        methods: {
            openHowTo: function() {
                ai_helper.makePost('aiHelper', 'about', {}, null,function(respond) {
                    if (respond.status === 'OK') {
                        document.getElementById('aboutBlock').innerHTML = respond.data;
                    }
                });

                this.$modal.show('how-to');
            },
            closeHowTo: function() {
                this.$modal.hide('how-to')
            }
        },
        mounted() {
            // this.$modal.show('sale')
        },
        created() {
            let self = this;

            let user = this.$session.get('user')
            if ((user.Deal == 1 && user.parent == 0) || (user.Deal == 1 && user.accDealerSale == 1)) {
                self.partner = true
            }

            let params = {
                url: 'https://sale.katris.ru/proxy/',
                // url: 'https://sale.katris.ru/proxy/AI_HELPER_45745673029734/',
                session: this.$session.get('user')
            };

            // ai_helper.debug = true;
            ai_helper.init(params, function() {
                if (ai_helper.stored != null) {
                    ai_helper.restoreComplects();

                    let allInBusket = true;
                    for (let set in ai_helper.complects) {
                        if (!ai_helper.complects[set].inBusket) allInBusket = false;
                        // console.log('set.inBusket', set.inBusket)
                    }
                    // console.log('allInBusket', allInBusket)
                    if (!allInBusket) self.$router.push({path: '/configurator'});
                }
            });

            this.count = this.$countGlobal;

            let data = {id: 0, count: 0, square: 0};
            ai_helper.makePost('aiHelper', 'init_info', data, null, function(respond) {
                if (respond.status === 'OK') {
                    respond = respond.data;
                    self.menu = respond.complects;

                    for (let key in self.menu) {
                        if (self.menu[key].id_good == 20000221 && self.menu[key].alt_folder == 'универсал(ПАл),Слип,Тюль') {
                            self.menu[key].alt_folder = 'универсал (ПАл), Слип, Тюль';
                        }

                        for (let key2 in respond.crutch) {
                            if (Object.keys(respond.crutch[key2])[0] == self.menu[key].id_good && respond.crutch[key2][self.menu[key].id_good] == self.menu[key].parm1) {
                                self.menu[key].action = true;
                            }
                        }

                        switch (self.menu[key].folder) {
                            case "Горизонтальные жалюзи":
                                self.menu[key].image = 'holis.png';
                                break;
                            case "Вертикальные жалюзи":
                                self.menu[key].image = 'verticalplastic.png';
                                break;
                            case "Горизонтальные жалюзи KS-25":
                                self.menu[key].image = 'ks25.png';
                                break;
                            case "Рулонные шторы":
                                switch (self.menu[key].alt_folder) {
                                    case "D-25":
                                        self.menu[key].image = 'd25.png';
                                        break;
                                    case "линейки D-38":
                                        self.menu[key].image = 'd38new.png';
                                        break;
                                    case "MINI":
                                        self.menu[key].image = 'mini.png';
                                        break;
                                    case "линейки UNI":
                                        self.menu[key].image = 'uni1.png';
                                        break;
                                    case "линейки CLIC":
                                        self.menu[key].image = 'clic.png';
                                        break;
                                    case "Zebra Slim":
                                        self.menu[key].image = 'zebraslim.png';
                                        break;
                                }
                                break;
                            case "Профильный Карниз":
                                switch (self.menu[key].alt_folder) {
                                    case "I-профиль":
                                        self.menu[key].image = 'shapedcornice.png';
                                        break;
                                    case "Парма,Открытая система":
                                        self.menu[key].image = 'shapedcornice2.png';
                                        break;
                                    case "универсал(ПАл),Слип,Тюль":
                                        self.menu[key].image = 'shapedcornice3.png';
                                        break;
                                }
                                break;
                            case "Круглый Карниз":
                                switch (self.menu[key].alt_folder) {
                                    case "16":
                                        self.menu[key].image = 'roundcornice.png';
                                        break;
                                    case "19":
                                        self.menu[key].image = 'roundcornice2.png';
                                        break;
                                    case "25":
                                        self.menu[key].image = 'roundcornice3.png';
                                        break;
                                }
                                break;
                        }
                    }

                    // console.log(self.menu)
                    // console.log(ai_helper.complects)
                    for (let i = 0; i < ai_helper.complects.length; i++) {
                        if (ai_helper.complects[i]) {
                            for (let key in self.menu) {
                                if (self.menu[key].id == ai_helper.complects[i].id) {
                                    self.menu.splice(key, 1);
                                }
                            }
                        }
                    }

                    // console.log(self.menu)
                } else {
                    console.error(respond)
                }
            });
        }
    }
</script>

<style scoped>
    .card-body {
        min-height: 122px;
    }

    .card div img {
        /*position: absolute;*/
        /*bottom: 10px;*/
        /*right: 10px;*/
        top: 0;
        left: 0;
        width: 90%;
    }

    aside ol li {
        padding: 10px 0;
        border-bottom: 1px solid #a2a2a2;
        position: relative;
    }
    aside ol li:last-of-type {
        border: none;
    }
    aside ol li a {
        padding-right: 30px;
        display: block;
    }
    aside ol li a:first-of-type:after {
        position: absolute;
        border-top: 2px solid #8c8c8c;
        border-right: 2px solid #8c8c8c;
        content: '';
        width: 9px;
        height: 9px;
        top: 17px;
        right: 15px;
        transform: rotate(45deg);
    }

    .card-img-top {
        height: 120px;
        text-align: center;
    }
    .card-img-top i {
        margin-top: 45px;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 790px;
        height: 475px;
        border: 4px solid #0283c4;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;

        background-image: url('./../assets/img/modal50sale.png');
        background-repeat: no-repeat;
        background-position: left;
        background-size: 305px;

        position: relative;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
